module.exports = __webpack_public_path__ + "static/media/Bristol Corners -10 20 14.ef7b75d9.pdf";